import { SegmentData } from '../types'
import LinkCell from './LinkCell'

const OverviewTitleCell = ({ segment: { id, title } }: SegmentData) => {
  const url = `/users/segments/${id}`

  return (
    <LinkCell
      text={title}
      url={url}
    />
  )
}

export default OverviewTitleCell
